import { showToastV2 } from '@dealstack/frontend/shared/mechanism/toast/useToastV2';
import type { TranslateFunction } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.types';
import type { I18Namespaces } from '@dealstack/shared/lib/common/i18n/i18n';

/** The skip/defer lists every bulk prepare/initiate response carries. */
export interface BulkSignSkipLists {
	skippedInstanceIds?: string[];
	witnessSkippedInstanceIds?: string[];
	deferredInstanceIds?: string[];
}

/**
 * Warn about documents the backend held back from the batch. Each list has its own
 * remedy, so each gets its own toast: an ADVANCED signer needs a different signing
 * method, a witness-requiring document needs signing one at a time so a witness can
 * be nominated, and a deferred slot only needs another bulk round.
 */
export const showBulkSignSkipNotices = (
	{ skippedInstanceIds, witnessSkippedInstanceIds, deferredInstanceIds }: BulkSignSkipLists,
	tMipManage: TranslateFunction<I18Namespaces.MIP_MANAGE>
): void => {
	if (skippedInstanceIds && skippedInstanceIds.length > 0) {
		showToastV2({
			state: 'warning',
			title: tMipManage('documents_page.bulk_sign.skipped_advanced_signers'),
			message: tMipManage('documents_page.bulk_sign.skipped_advanced_signers_description', {
				count: skippedInstanceIds.length,
			}),
		});
	}

	if (witnessSkippedInstanceIds && witnessSkippedInstanceIds.length > 0) {
		showToastV2({
			state: 'warning',
			title: tMipManage('documents_page.bulk_sign.skipped_witness_required'),
			message: tMipManage('documents_page.bulk_sign.skipped_witness_required_description', {
				count: witnessSkippedInstanceIds.length,
			}),
		});
	}

	if (deferredInstanceIds && deferredInstanceIds.length > 0) {
		showToastV2({
			state: 'warning',
			title: tMipManage('documents_page.bulk_sign.deferred_slots'),
			message: tMipManage('documents_page.bulk_sign.deferred_slots_description', {
				count: deferredInstanceIds.length,
			}),
		});
	}
};
